module.exports = __webpack_public_path__ + "static/media/24_lampa_51.56_2.04.11940128.png";